import React from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import { FreeMode, Pagination } from "swiper";

import CourseCard from "./Course_Card";

const CourseSlider = ({ Courses }) => {
  return (
    <>
      {Courses?.length ? (
        <Swiper
          navigation={true}
          slidesPerView={1}
          spaceBetween={25}
          loop={true}
          modules={[FreeMode, Pagination]}
          breakpoints={{
            1024: {
              slidesPerView: 3,
            },
          }}
          className='max-h-[30rem] mx-auto'
        >
          {Courses?.map((course, i) => (
            <SwiperSlide key={i}>
              <CourseCard
                course={course}
                Height={"h-[200px] w-[330px] md:w-[450px]  md:h-[280px]"}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <p className='text-xl text-richblack-5'>No Course Found</p>
      )}
    </>
  );
};

export default CourseSlider;
